import { Button, Heading, Icon } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './SuccessStage.styled';
export const SuccessStage = ({ onOrderSamples, onClose }) => {
    return (React.createElement(S.Content, null,
        React.createElement(S.SuccessIconContainer, null,
            React.createElement(Icon, { component: TickIcon, height: 16 })),
        React.createElement(Heading, { type: "h6", weight: "semibold" }, "Welcome to Fourthwall Pro!"),
        React.createElement(S.Text, null, "You\u2019ve unlocked powerful tools to grow your brand like never before. Let\u2019s build something amazing together. \uD83D\uDE80"),
        React.createElement(S.ButtonsContainer, null,
            React.createElement(Button, { label: "Order samples", appearance: "primary", fullWidth: true, onClick: onOrderSamples }),
            React.createElement(Button, { label: "Close", appearance: "secondary", fullWidth: true, onClick: onClose }))));
};
